import { 
  setMemberList,
  // setSelectedMemberList,
  setServiceList,
  setServiceListItem,
  setAssignList,
  setManagerList,
  setSupervisorList,
  setDistrictList,
  //setUsernameErrorMessage,
  //setPasswordErrorMessage,
  //setUsername,
  //setPassword,
  //setPasswordError,
  //setUsernameError,
  //setLoading4SignIn,
  //reset4SignIn,
  //setCredential,
  setDisplayMode,
  setServiceOptionList,
  setServiceOptionListItem,
  reset4All,
} from '../Redux/allReducer';

import { 
  //setMemberList,
  // setSelectedMemberList,
  //setServiceList,
  //setAssignList,
  //setManagerList,
  //setSupervisorList,
  setUsernameErrorMessage,
  setPasswordErrorMessage,
  setUsername,
  setPassword,
  setPasswordError,
  setUsernameError,
  setLoading4SignIn,
  //reset4SignIn,
  setCredential,
  reset4SignIn,
} from '../Redux/signInReducer';

export default { setDistrictList, setServiceOptionListItem, setServiceOptionList, setDisplayMode, reset4SignIn, reset4All, setCredential, setUsernameErrorMessage, setPasswordErrorMessage, setUsername, setPassword, setPasswordError, setUsernameError, setSupervisorList, setManagerList, setAssignList, setServiceListItem, setServiceList, setMemberList };